import { SvgIcon, SvgIconProps } from '@mui/material';
import { FC } from 'react';

export const IconArrowRight: FC<SvgIconProps> = props => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path d="M5 10H15M15 10L10 5M15 10L10 15" stroke="#202723" strokeWidth="1.4" />
  </SvgIcon>
);
